module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "SiteFooter"
  }, [_c('container', [_c('div', {
    staticClass: "SiteFooter-content t-antialiased"
  }, [_c('p', {
    staticClass: "t-caps-md c-grey-xlt2"
  }, [_vm._v("Contact Benj + Sara")]), _vm._v(" "), _c('p', {
    staticClass: "t-text-sm c-grey-lt"
  }, [_c('a', {
    attrs: {
      "href": ("mailto:" + (_vm.global.site.email.value))
    }
  }, [_vm._v(_vm._s(_vm.global.site.email.label))]), _vm._v("   \n          ")]), _vm._v(" "), _c('break', {
    attrs: {
      "size": "0.75"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "t-caps-md c-grey-xlt2"
  }, [_vm._v("Follow us")]), _vm._v(" "), _c('ul', {
    staticClass: "SiteFooter-social t-text-sm c-grey-lt"
  }, _vm._l((_vm.global.site.social), function(item) {
    return _c('li', [_c('a', {
      attrs: {
        "href": item.link
      }
    }, [_vm._v("\n              " + _vm._s(item.title) + "\n              ")])])
  }), 0)], 1), _vm._v(" "), _c('break', {
    attrs: {
      "size": "0.5"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "SiteFooter-finePrint t-caps-sm c-grey-md"
  }, [_c('span', [_vm._v("Code by Darin Reid.")]), _vm._v(" "), _c('span', [_vm._v("Our "), _c('a', {
    attrs: {
      "href": "/privacy-policy"
    }
  }, [_vm._v("Privacy Policy")]), _vm._v(".")]), _vm._v(" "), _c('span', [_vm._v("Copyright © " + _vm._s(_vm.year) + ".")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a9ce9c7e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SiteFooter.vue
// module id = 790
// module chunks = 1474